import Preferences from './Preferences'

const Theme = {
    // Returns true if currently-effective theme is dark,
    // respecting saved preference or falling back to system.
    getIsDark() {
        const saved = Preferences.getValue('/', 'theme', 'value', null)
        if (saved === 'dark' || saved === true) return true
        if (saved === 'light' || saved === false) return false
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    },

    // Returns saved selection: 'dark' | 'light' | 'system'.
    // Handles legacy boolean values from before the three-way setting.
    getSaved() {
        const saved = Preferences.getValue('/', 'theme', 'value', null)
        if (saved === 'dark' || saved === true) return 'dark'
        if (saved === 'light' || saved === false) return 'light'
        return 'system'
    },

    apply(isDark) {
        document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light')
        document.documentElement.classList.toggle('dark', isDark)
    },

    // Set theme to 'dark', 'light', or 'system'.
    set(value) {
        Preferences.setValue('/', 'theme', 'value', value === 'system' ? null : value)
        const isDark = value === 'dark'
            || (value === 'system' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
        Theme.apply(isDark)
    },
}

export default Theme
